import React, { useState, useEffect, useRef } from "react";
import "../../App.css";

// Updated Software Products page with back button
function FeatureSection({ title, text, imgSrc, imgAlt, reverse }) {
  return (
    <section className={`esri-feature-section${reverse ? ' reverse' : ''}`}>
      <div className="section__container esri-feature-container">
        <div className={`esri-feature-image${reverse ? ' reverse' : ''}`}>
          <img src={imgSrc} alt={imgAlt} />
        </div>
        <div className={`esri-feature-text${reverse ? ' reverse' : ''}`}>
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
      </div>
    </section>
  );
}

export default FeatureSection;